/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResourceAvailability } from '../../models/resource-availability';

export interface FindResourceAvailabilities$Params {
  resourceIds: string;
  start: string;
  end: string;
  bookId: string;
  excludeAppointmentId?: string;
}

export function findResourceAvailabilities(http: HttpClient, rootUrl: string, params: FindResourceAvailabilities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResourceAvailability>>> {
  const rb = new RequestBuilder(rootUrl, findResourceAvailabilities.PATH, 'get');
  if (params) {
    rb.query('resourceIds', params.resourceIds, {});
    rb.query('start', params.start, {});
    rb.query('end', params.end, {});
    rb.query('bookId', params.bookId, {});
    rb.query('excludeAppointmentId', params.excludeAppointmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResourceAvailability>>;
    })
  );
}

findResourceAvailabilities.PATH = '/api/agn-resources/availability';
